import React, { useEffect } from 'react'
import axios from 'axios';
import actionTypes from "./store/actionTypes";
import AppRouter from './router';
import { useDispatch, useSelector } from 'react-redux';

const App = props => {
  const { setShopDomain, setShopId, setFetchingData, saveSuppliers, savePurchaseOrders, saveCurrency, changeFetchingPos } = actionTypes

  const { serverLink } = useSelector(state => state.ConfigReducer)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch({ type: setShopDomain, payload: getShopDomain() })
  }, [])

  const getShopDomain = () => {
    let shopDomain;
    const params = new URLSearchParams(window.location);
    if (window.location.ancestorOrigins !== undefined) {
      shopDomain = window.location.ancestorOrigins['0'].replace("https://", "")
    } else if (params.search && params.search.get('shop') !== undefined) {
      console.log('else if 1');
      shopDomain = params.search.get('shop')
    } else if (params.href && params.href.get('shop') !== undefined) {
      console.log('else if 2');
      shopDomain = params.href.get('shop')
    }
    if (shopDomain) {
      extractVendors(serverLink, shopDomain)
    }

    return shopDomain
  }
  const extractVendors = (serverLink, shopDomain) => {
    const ifConnected = window.navigator.onLine;
    if (ifConnected) {
      dispatch({ type: setFetchingData, payload: true })
      dispatch({ type: changeFetchingPos, payload: true })
      const options = {
        method: 'GET',
        url: `${serverLink}/suppliers/extract/${shopDomain}`,
      }
      axios(options)
        .then(({ status, data }) => {
          dispatch({ type: setFetchingData, payload: false })
          if (status >= 500) {
            alert("Something went wrong! Please try later.")
          } else {
            if (data.length > 0 && typeof data !== 'string') {
              dispatch({ type: saveSuppliers, payload: data })
              dispatch({ type: setShopId, payload: data[0].shopId })
              getCurrency(data[0].shopId)
              getPurchaseOrderList(serverLink, data[0].shopId)
            }
          }
        })
        .catch(error => {
          dispatch({ type: setFetchingData, payload: false })
          console.log("error", error)
          alert(error)
        })
    } else {
      alert("Please, Check Your Internet Connection!")
    }
  }
  const getCurrency = shopId => {
    const ifConnected = window.navigator.onLine;
    if (ifConnected) {
      const options = {
        method: 'GET',
        url: `${serverLink}/shop/currency/${shopId}`,
      }
      axios(options)
        .then(({ data }) => {
          dispatch({ type: saveCurrency, payload: data })
        })
        .catch(error => {
          console.log("error", error)
          alert(error)
        })
    } else {
      alert("Please, Check Your Internet Connection!")
    }
  }

  const getPurchaseOrderList = (serverLink, shopId) => {
    const ifConnected = window.navigator.onLine;
    if (ifConnected) {
      dispatch({ type: changeFetchingPos, payload: true })
      const options = {
        method: 'GET',
        url: `${serverLink}/order/purchaseOrders/${shopId}`,
      }
      axios(options)
        .then(async ({ data }) => {
          dispatch({ type: savePurchaseOrders, payload: data })
          // await calculateCutOff(data)
          dispatch({ type: changeFetchingPos, payload: false })
        })
        .catch(error => {
          dispatch({ type: changeFetchingPos, payload: false })
          console.log("error", error)
          alert(error)
        })
    } else {
      alert("Please, Check Your Internet Connection!")
    }
  }

  return (<>
    <AppRouter />
  </>
  )
}

export default App